module.exports = __webpack_public_path__ + "img/rock.bd38d8ee.webp";